import { getFeatureAppNames } from './FinanceUtils';
export const trackLayerClose = (trackingService, value, appContext) => {
    const { eventName, componentName } = getFeatureAppNames(appContext);
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: `${eventName} - close modal layer`,
                },
                attributes: {
                    componentName,
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: 'text link',
                    value,
                    pos: '',
                },
            },
            componentUpdate: {
                page: {
                    pageInfo: {
                        pageID: '',
                    },
                    attributes: {
                        promotionName: '',
                    },
                },
            },
        });
    }
};
export const trackAdditionalFinanceInfo = (trackingService, eventName) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName,
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: 'icon',
                    value: '',
                    pos: '',
                },
            },
        });
    }
};
export const trackChangePuchaseModality = (trackingService, label, value) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp financing - change purchase modality',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value,
                    pos: '',
                },
            },
            componentUpdate: {
                attributes: {
                    version: '',
                    selectedPurchaseModality: value,
                },
            },
        });
    }
};
export const trackChangeFinancingProduct = (trackingService, label, value) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp financing - change financing product',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'radio button',
                    value,
                    pos: '',
                },
            },
            componentUpdate: {
                attributes: {
                    version: '',
                    selectedFinancingProduct: value,
                },
            },
        });
    }
};
export const trackDynamicCTAClick = (trackingService, label, value) => {
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: 'vtp click on request financing',
                },
                attributes: {
                    componentName: 'vtp-carInfo',
                    label,
                    targetURL: '',
                    clickID: '',
                    elementName: 'button',
                    value,
                    pos: '',
                },
            },
        });
    }
};
